import { m } from "mithril";
import paginationComponent from "../../components/pagination/pagination.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import { codeMasterType } from "../../config/constants";
import codeMasterModel from "../../models/common/code-master.model";
import GscmDivisionModel from "../../models/gscm-division/gscm-division.model";
import languageModel from "../../models/language.model";
import ModelManagementModel from "../../models/model-management/model-management.model";
import ViewBase from "../view-base.view";
import ModelUdfDataDefinitionDialog from "./model-udf-data-definition.dialog";

/**
 * Model UDF Data Management View
 * 
 * 
 * 
 * @author cmc.nttruong1
 */
export default function ModelUDFDataManagementView() {
  ViewBase.call(this);

  const STATUS_ACTIVITY = 'Activity';
  const MODEL_CODE = 'MODEL CD';
  const MODEL_ALIAS = 'ALIAS';
  const MODEL_DES = 'MODEL DESCRIPTION';
  const MODEL_STATUS = 'ACTIVE';
  const STATIC_COLUMNS = [MODEL_CODE, MODEL_DES, MODEL_ALIAS, MODEL_STATUS, 'XX_MODEL_CD'];
  const SEARCH_SECTION = 'search-section';
  const BOOTSTRAP_INVALID_CLASS = 'is-invalid';
  const GSCM_DIV_SELECT_ID = 'gscmDivFilter';
  const FORM_ID = 'ModelUdfDataFormFilter'

  const DEFAULT_FILTERS = {
    gscmDivision: '',
    modelCode: '',
    modelAlias: '',
    status: ''
  };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let models = [];
  let statuses = [];
  let gscmDivisionList = [];
  let selectedModelCode = '';
  let selectedRows = [];
  let dynamicObject = null;
  let dynamicColumns = 0;
  let errorMessage = '';
  let isModelInformationOpen = false;

  const SELECT_ALL_CHECKBOX_ID = "modelUDFDataSelectAllCheckbox";
  const CHECKBOX_NAME = "modelUDFDataCheckbox";

  const selectRow = (checked, item) => {
    if (checked) {
      selectedRows.push(item);
    } else {
      selectedRows = selectedRows.filter(
        (data) => data[MODEL_CODE] !== item[MODEL_CODE]
      );
    }

    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    if (selectedRows.length === 0) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = false;
    }
    else {
      selectAllCheckbox.indeterminate = true;
      selectAllCheckbox.checked = false;
    }
  };

  const onCheckAll = (event) => {
    let checkboxes = document.querySelectorAll(
      `input[type='checkbox'][name='${CHECKBOX_NAME}']`
    );

    selectedRows = [];

    if (event.target.checked || event.target.indeterminate) {
      models.forEach((item) => {
        selectedRows.push(item);
      });

      checkboxes.forEach((item) => {
        item.checked = true;
      });
    } else {
      checkboxes.forEach((item) => {
        item.checked = false;
      });
    }
    event.target.indeterminate = false;
  };

  const uncheckAllCheckboxes = () => {
    const arr = document.querySelectorAll(`input[name=${CHECKBOX_NAME}]`);
    if (arr.length === 0) {
      return;
    }
    arr.forEach((checkbox) => {
      checkbox.checked = false;
    });
    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    selectAllCheckbox.indeterminate = false;
    selectAllCheckbox.checked = false;

    selectedRows = [];
  };

  const onDeleteAction = () => {
    if (selectedRows.length > 0) {
      this.showConfirm(
        this.getText('LT00000959', "Are you sure you want to clear ALL fields of the selected data(s)?"),
        this.getText('LT00000960', "Clear UDF Data fields"),
        (e) => {
          if (e == "YES") {
            this.showLoading();
            ModelManagementModel.deleteModelUDFData(
              selectedRows.map((item) => item[MODEL_CODE])
            )
              .then(searchModels)
              .then(() => {
                this.showMessage(this.getText('EM00000004', 'Success'));
              })
              .catch(() => {
                this.showErrorMessage(this.getText("EM00000142", "Error"));
              })
              .finally(() => { this.hideLoading() });
          }
        }
      );
    } else {
      this.showErrorMessage(this.getText("LT00000719", "No items selected"));
    }
  };

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    searchModels();
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    searchModels();
  };

  const toQueryParams = (params) => {
    return Object.assign(
      {
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
        modelCode: params.modelCode,
        modelAlias: params.modelAlias,
        modelStatus: params.status,
        gscmDivision: params.gscmDivision,
      },
    );
  };

  const getStatuses = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.modelStatus })
      .then((result) => {
        statuses = result
      })
      .catch((errror) => { this.handleError(errror); })
  }

  const getGSCMDivisions = () => {
    GscmDivisionModel.getGscmDivisionHierarchy()
      .then((result) => {
        gscmDivisionList = [];
        if (result.length > 0) {
          gscmDivisionList = result.flatMap(item => item['subProductHirList']);
        }
      })
      .catch((error) => { this.handleError(error); })
  }

  const validateFilters = () => {
    let form = document.getElementById(FORM_ID);
    form.classList.add('was-validated');
    const gscmDivFilter = document.getElementById(GSCM_DIV_SELECT_ID)
    if (!filters.gscmDivision) {
      gscmDivFilter.classList.add(BOOTSTRAP_INVALID_CLASS);
      errorMessage = this.getText('LT00000857', 'Please select a GSCM Division.');
      return false;
    }

    gscmDivFilter.classList.remove(BOOTSTRAP_INVALID_CLASS);
    return true;
  }

  const searchModels = () => {
    this.showLoading();
    uncheckAllCheckboxes();
    return ModelManagementModel.getModelUDFData(toQueryParams(filters))
      .then((result) => {
        models = [];
        if (result) {
          models = result.data || [];
          pagination.totalItems = result.total || 0;
          dynamicObject = models.length > 0 ? models[0] : null;
          if (dynamicObject) {
            dynamicColumns = Object.keys(dynamicObject).length;
          }
        }
      })
      .catch((error) => { this.handleError(error); })
      .finally(() => { this.hideLoading(); })
  }

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    pagination = structuredClone(DEFAULT_PAGINATION);
    models = [];
  }

  const openModelInformation = (modelCode) => {
    selectedModelCode = modelCode;
    isModelInformationOpen = true;
  }

  const closeModelInformation = () => {
    isModelInformationOpen = false;
  }

  const saveComplete = () => {
    isModelInformationOpen = false;
    searchModels();
    this.showMessage(
      this.getText('LT00000953', 'Update completed'),
    )
  }

  const _initControls = () => {
    getGSCMDivisions();
    getStatuses();
  }

  return {
    oninit: () => {
      _initControls();
    },
    view: () => {
      return [
        /* SEARCH */
        m(".d-flex.flex-column.align-items-end.gap-2.mb-3",
          m(`a.btn.btn-primary[data-bs-toggle="collapse"][href="#${SEARCH_SECTION}"][aria-controls="${SEARCH_SECTION}"][aria-expanded="false"]`,
            m("i.bi.bi-filter"),
            this.getText("LT00000232", "Filter")
          ),
          m(`.collapse.show#${SEARCH_SECTION}.w-100`,
            m('.card',
              m('.card-body',
                m('.form.row.g-2',
                  { id: FORM_ID },
                  m('.col-md-3.col-lg-3.position-relative',
                    m('label.form-label.mandatory', this.getText('LT00000241', 'GSCM Division')),
                    m('div', { id: GSCM_DIV_SELECT_ID },
                      m(SingleSelectComponent, {
                        keyOnly: true,
                        items: gscmDivisionList,
                        selectedItem: filters.gscmDivision,
                        onSelect: (s) => {
                          filters.gscmDivision = s;
                        }
                      }),
                    ),
                    m('.invalid-tooltip', errorMessage)
                  ),
                  m('.col-md-3.col-lg-3.position-relative',
                    m('label.form-label', this.getText('LT00000728', 'Model Code')),
                    m('input', {
                      class: 'form-control ',
                      type: 'text',
                      value: filters.modelCode,
                      onchange: (e) => { filters.modelCode = e.target.value }
                    })
                  ),
                  m('.col-md-3.col-lg-3.position-relative',
                    m('label.form-label', this.getText('LT00000898', 'Model Alias')),
                    m('input', {
                      class: 'form-control ',
                      type: 'text',
                      value: filters.modelAlias,
                      onchange: (e) => { filters.modelAlias = e.target.value }
                    })
                  ),
                  m('.col-md-3.col-lg-3.position-relative',
                    m('label.form-label', this.getText('LT00000015', 'Status')),
                    m(SingleSelectComponent, {
                      keyOnly: true,
                      filterable: false,
                      items: statuses,
                      selectedItem: filters.status,
                      onSelect: (s) => {
                        filters.status = s;
                      }
                    })
                  ),
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary',
                      {
                        onclick: () => {
                          pagination.pageIndex = DEFAULT_PAGINATION.pageIndex;
                          if (validateFilters()) {
                            searchModels();
                          }
                        }
                      },
                      this.getText("LT00000001", "Search")
                    ),
                    m('button.btn.btn-white',
                      {
                        onclick: () => {
                          clearFilter();
                        }
                      },
                      this.getText("LT00000031", "Clear")
                    )
                  )
                )
              )
            )
          )
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.row.g-2',
              models.length > 0 &&
              m(".col-12.d-flex.justify-content-between",
                m(".d-flex.gap-2",
                  m("button.btn.btn-danger",
                    {
                      onclick: () => {
                        onDeleteAction();
                      },
                    },
                    this.getText('LT00000961', "Clear UDF Data")
                  )
                ),
              ),
              m('.col-12',
                m('.table-responsive',
                  m('table.table',
                    m('thead',
                      m('tr.align-middle.center',
                        m("th",
                          m("input", {
                            tabindex: -1,
                            id: SELECT_ALL_CHECKBOX_ID,
                            type: "checkbox",
                            onchange: onCheckAll,
                          })
                        ),
                        m('th', this.getText('LT00000955', MODEL_CODE)),
                        m('th', this.getText('LT00000956', MODEL_ALIAS)),
                        m('th', this.getText('LT00000957', MODEL_DES)),
                        m('th', this.getText('LT00000958', MODEL_STATUS)),
                        !!dynamicObject &&
                        Object.keys(dynamicObject).map((key) => {
                          if (!STATIC_COLUMNS.includes(key)) {
                            return m('th', this.getText('', key));// this label is dynamic
                          }
                        }) // return dynamic columns head
                      )
                    ),
                    m('tbody',
                      models.length == 0 &&
                      m(
                        "tr",
                        { class: "align-middle" },
                        m(
                          "td",
                          { colspan: 5 + dynamicColumns },
                          languageModel.getText(
                            "EM00000141",
                            "No records found."
                          )
                        )
                      ),
                      models.map((data, index) => {
                        const active = data[MODEL_STATUS] === STATUS_ACTIVITY;

                        return m('tr.align-middle.center',
                          m("td",
                            m("input", {
                              id: `${CHECKBOX_NAME}${index}`,
                              type: "checkbox",
                              tabindex: -1,
                              name: CHECKBOX_NAME,
                              onchange: (event) => {
                                selectRow(event.target.checked, data);
                              },
                            })
                          ),
                          m('td',
                            m('a.cursor-pointer',
                              {
                                onclick: () => openModelInformation(data[MODEL_CODE]),
                              },
                              data[MODEL_CODE]
                            )),
                          m('td', m('span.cursor-text', data[MODEL_ALIAS])),
                          m('td', m('span.cursor-text', data[MODEL_DES])),
                          m('td', m(`span.badge.rounded-pill${active ? '.green-bg-status' : '.danger-bg-status'}`, active ? this.getText('LT00000025', 'Active') : this.getText('LT00000896', 'Inactive'))),
                          Object.entries(data).map(([key, value]) => {
                            if (!STATIC_COLUMNS.includes(key)) {
                              return m('td', m('span.cursor-text', value));
                            }
                          }),
                        );
                      })
                    )
                  )
                )
              )
            ),
            m('.col-12', m(paginationComponent,
              {
                currentPage: pagination.pageIndex,
                pageSize: pagination.pageSize,
                totalItems: pagination.totalItems,
                onPageChanged: onPageChanged,
                onPageSizeChanged: onPageSizeChanged,
              }
            ))
          )
        ),

        isModelInformationOpen &&
        m(ModelUdfDataDefinitionDialog,
          {
            modelCode: selectedModelCode,
            onClose: closeModelInformation,
            onSaveComplete: saveComplete,
            staticColumns: STATIC_COLUMNS,
          }),
        this.getBaseViews()
      ];
    }
  };
}
